export default { // 该需求运行在评估app中
  tabs: [
    {
      name: 'CarSourceList',
      path: '/saas/carSourceList',
      component: () => import('./src/carSourceList'),
      meta: {
        title: '我的评估车源',
        keepAlive: true
      }
    },
    {
      name: 'SearchSaasCarSource',
      path: '/saas/searchSaasCarSource',
      component: () => import('./src/searchSaasCarSource'),
      meta: {
        title: '请输入车车号或者车源号'
      }
    },
    {
      name: 'MoreParamsConfig',
      path: '/saas/moreParamsConfig',
      component: () => import('./src/moreParamsConfig'),
      meta: {
        title: '参数配置',
      }
    },
    {
      name: 'OwnerPriceCertificatesInfo',
      path: '/saas/ownerPriceCertificatesInfo',
      component: () => import('./src/ownerPriceCertificatesInfo'),
      meta: {
        title: '车主价格证件信息',
      }
    },
    {
      name: 'OperationRecord',
      path: '/saas/operationRecord',
      component: () => import('./src/operationRecord'),
      meta: {
        title: '车源操作记录',
      }
    },
    // {
    //   name: 'jishuyuyan',
    //   path: '/saas/jishuyuyan',
    //   component: () => import('./src/jishuyuyan'),
    //   meta: {
    //     title: '技术预研',
    //   }
    // },
    {
      name: 'parkingRights',
      path: '/saas/parkingRights',
      component: () => import('./src/parkingRights'),
      meta: {
        title: '车位权益',
      }
    }
  ]
}
